/**
 * Abbreviations for the short fields on Florida title paperwork.
 *
 * HSMV 82993 and 83330 cap Make, Color and Body at six characters. That is
 * not an accident: the state expects the standard NCIC-style codes that
 * appear on titles and registrations, not a truncated brand name. "VOLK" is
 * what a tag agency reads; "Volksw" is what a bug produces.
 */

const MAKE: Record<string, string> = {
  ACURA: "ACUR", "ALFA ROMEO": "ALFA", ASTON: "ASTO", AUDI: "AUDI",
  BENTLEY: "BENT", BMW: "BMW", BUICK: "BUIC", CADILLAC: "CADI",
  CHEVROLET: "CHEV", CHRYSLER: "CHRY", DODGE: "DODG", FERRARI: "FERR",
  FIAT: "FIAT", FORD: "FORD", GENESIS: "GENE", GMC: "GMC",
  HONDA: "HOND", HUMMER: "HUMM", HYUNDAI: "HYUN", INFINITI: "INFI",
  ISUZU: "ISU", JAGUAR: "JAGU", JEEP: "JEEP", KIA: "KIA",
  "LAND ROVER": "LNDR", LEXUS: "LEXS", LINCOLN: "LINC", LOTUS: "LOTU",
  MASERATI: "MASE", MAZDA: "MAZD", "MERCEDES-BENZ": "MERZ", MERCURY: "MERC",
  MINI: "MINI", MITSUBISHI: "MITS", NISSAN: "NISS", OLDSMOBILE: "OLDS",
  PLYMOUTH: "PLYM", PONTIAC: "PONT", PORSCHE: "PORS", RAM: "RAM",
  "ROLLS-ROYCE": "ROLL", SAAB: "SAAB", SATURN: "SATN", SCION: "SCIO",
  SMART: "SMAR", SUBARU: "SUBA", SUZUKI: "SUZI", TESLA: "TESL",
  TOYOTA: "TOYT", VOLKSWAGEN: "VOLK", VOLVO: "VOLV",
};

const COLOR: Record<string, string> = {
  BLACK: "BLK", WHITE: "WHI", SILVER: "SIL", GRAY: "GRY", GREY: "GRY",
  RED: "RED", BLUE: "BLU", GREEN: "GRN", BROWN: "BRO", BEIGE: "BGE",
  GOLD: "GLD", ORANGE: "ORG", YELLOW: "YEL", BURGUNDY: "MAR",
  PURPLE: "PLE", TAN: "TAN", MAROON: "MAR",
};

const BODY: Record<string, string> = {
  SEDAN: "4D", COUPE: "2D", HATCHBACK: "HB", CONVERTIBLE: "CV",
  WAGON: "SW", SUV: "UT", CROSSOVER: "UT", MINIVAN: "VN", VAN: "VN",
  PICKUP: "PK", TRUCK: "TK",
};

/** Fall back to a clipped uppercase value rather than dropping the field. */
function lookup(table: Record<string, string>, value: string, max: number): string {
  const v = value.trim().toUpperCase();
  if (!v) return "";
  const hit = table[v];
  if (hit) return hit;
  // Try the first word, which handles "FORD MOTOR CO" and "BLUE METALLIC".
  const first = v.split(/[\s/,-]+/)[0] ?? "";
  return (table[first] ?? v).slice(0, max);
}

export const makeCode = (v: string, max = 6) => lookup(MAKE, v, max);
export const colorCode = (v: string, max = 6) => lookup(COLOR, v, max);
export const bodyCode = (v: string, max = 6) => lookup(BODY, v, max);
